import React, { useState } from 'react';
import { PlusIcon } from '../../../../components/icons';
import Button from '../../../../components/button/Button';
import { RoleCards } from './RoleCards';
import CreateRoleModal from './CreateRoleModal';
import { useBusinessRoles } from '../../../../customhooks/useBusinessRoles';
import { Spin } from 'antd';
import { SettingOutlined } from '@ant-design/icons';

const RolesManagement = () => {
    const [viewCreateForm, setViewCreateForm] = useState(false);
    const { isLoading, businessRoles, refetch, paging } = useBusinessRoles({
        page: 0,
        size: 50
    });

    const defaultR = businessRoles?.filter((role) => !role.corporateId);
    const customRoles = businessRoles?.filter((role) => role.corporateId);

    return (
        <div className='max-w-2xl mx-auto'>
            <Spin
                fullscreen
                spinning={isLoading}
                delay={500}
                indicator={
                    <SettingOutlined
                        style={{ fontSize: 100, color: '#329FC1' }}
                        spin
                    />
                }
            />
            <div className='hidden w-full lg:flex justify-end pt-6 pb-2'>
                <Button
                    text='Add custom role'
                    leftIcon={<PlusIcon color='#0088b2' />}
                    onClick={() => {
                        setViewCreateForm(true);
                    }}
                    variant='tertiary'
                    className='text-appcolorprimary px-0 hover:bg-transparent'
                />
            </div>
            <div className='space-y-2 rounded-xl lg:bg-[#F9FAFB] bg-white pt-2'>
                <Button
                    text='Add Custom Role'
                    leftIcon={<PlusIcon color='#fff' />}
                    onClick={() => {
                        setViewCreateForm(true);
                    }}
                    variant='primary'
                    className='w-[90%] lg:hidden my-4 mx-auto'
                />
                <RoleCards
                    title='Default Roles'
                    roles={defaultR}
                    refetch={refetch}
                />
                {customRoles?.length > 0 && (
                    <RoleCards
                        title='Custom Roles'
                        roles={customRoles}
                        isCustom
                        refetch={refetch}
                    />
                )}
            </div>

            {viewCreateForm && (
                <CreateRoleModal
                    openModal={viewCreateForm}
                    setOpenModal={setViewCreateForm}
                    refetch={refetch}
                />
            )}
        </div>
    );
};

export default RolesManagement;
